// metismenu is a jQuery plugin and expects `jQuery` / `$` on the global. webpack's ProvidePlugin
// used to supply them; Vite does not infer globals, so set them here. This module must be imported
// before any plugin that reads the global, so ES module evaluation order does the work.
import jQuery from 'jquery'

window.jQuery = jQuery
window.$ = jQuery

export default jQuery
